import { TAssetOperationTypeEnum } from '@/shared/hooks/use-assets-app-sync-events/use-assets-app-sync-events.types';
import { licensesApi } from '@/shared/redux/api/assets/licenses/licenses-api';
import { locksApi } from '@/shared/redux/api/assets/locks/locks-api';
import { useAppDispatch } from '@/shared/redux/hooks/hooks';
import { AssetTypeEnum } from '@/shared/types/types.generated';

export const useInvalidateLicenseTags = () => {
  const dispatch = useAppDispatch();

  const invalidateLicenseTags = (
    licenseId: string,
    operationType: TAssetOperationTypeEnum,
  ) => {
    switch (operationType) {
      case TAssetOperationTypeEnum.AssetCreated:
      case TAssetOperationTypeEnum.AssetUpdated:
      case TAssetOperationTypeEnum.AssetDeleted:
        dispatch(
          licensesApi.util.invalidateTags([
            { type: 'License', id: 'LIST' },
            'Groups' as const,
          ]),
        );
        break;
      case TAssetOperationTypeEnum.AssetLocked:
      case TAssetOperationTypeEnum.AssetUnlocked:
        dispatch(
          locksApi.util.invalidateTags([
            { type: 'Lock', id: `${AssetTypeEnum.License}:${licenseId}` },
          ]),
        );
        break;
    }
  };

  return {
    invalidateLicenseTags,
  };
};
